import invoiceIcon from 'assets/img/invoice-icon.svg';
import invoiceIconAction from 'assets/img/invoice-action.svg';
const TableInvoiceItem = ({ item }) => {
    return (
        <tr className="table-main-row projects-table-item">
            <td>
                <div className="d-flex align-items-center">
                    <img src={invoiceIcon} alt="" />
                    <p className="billing--paragraph opacity-100 fw-semibold px-2">
                        {item.invoice}
                    </p>
                </div>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{item.billingData}</td>
            <td>
                <div className="billing--item-status">
                    <span>{item.status?.toUpperCase()}</span>
                </div>
            </td>
            <td>{item.amount}</td>
            <td>{item.plan}</td>
            <td className="cursor-pointer">
                <img src={invoiceIconAction} alt="" />
            </td>
        </tr>
    );
};

export default TableInvoiceItem;
